<div class="wrapper-md">
    <app-breadcrumbs [items]="[
                     { url: '/notifications', text: 'notification_listTitle' },
                     {
                        url: '/notifications/' + data.Id,
                        text: 'notification_sendTitle'
                     }]"></app-breadcrumbs>

    <ng-container *ngIf="!data">
        <div class="form-actions">
            <button class="btn btn-outline" type="button" [routerLink]="['/notifications'] | localize">
                {{'close' | translate}}
            </button>
        </div>
    </ng-container>

    <ng-container *ngIf="data">
        <header class="content-header">
            <h1>
                {{'notification_title' | translate}} #{{data.Id}}
                <app-notification-status [value]="data.Status"></app-notification-status>
            </h1>
        </header>

        <form #form="ngForm" [class.was-validated]="isFormSubmitted">
            <div class="data-value">
                <label>{{'notification_lblType' | translate}}</label>
                <div>{{data.Type}} ({{data.Template}})</div>
            </div>

            <div class="form-field required">
                <label class="form-label">{{'notification_lblSender' | translate}}</label>
                <input class="form-control" [(ngModel)]="model.Sender" name="sender" required />
                <ng-container [ngTemplateOutlet]="validation"
                              [ngTemplateOutletContext]="{ validation: validations.sender }">
                </ng-container>
            </div>

            <div class="row">
                <div class="col-sm form-field required">
                    <label class="form-label">{{'notification_lblAvailableChannels' | translate}}</label>
                    <div>
                        <div *ngFor="let n of options.channel">
                            <app-checkbox name="availableChannel_{{n.value}}" [(ngModel)]="availableChannels[n.value]"
                                          (stateChange)="onAvailableChannelChange(n.value, $event)">
                                {{n.text}}
                            </app-checkbox>
                        </div>
                    </div>
                    <ng-container [ngTemplateOutlet]="validation"
                                  [ngTemplateOutletContext]="{ validation: validations.availableChannels }">
                    </ng-container>
                </div>

                <div class="col-sm form-field">
                    <label class="form-label">{{'notification_lblRequiredChannels' | translate}}</label>
                    <div>
                        <div *ngFor="let n of options.channel">
                            <app-checkbox name="requiredChannel_{{n.value}}" [(ngModel)]="requiredChannels[n.value]"
                                          (stateChange)="onRequiredChannelChange(n.value, $event)">
                                {{n.text}}
                            </app-checkbox>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-field" [class.required]="isFullContentRequired">
                <label class="form-label">{{'notification_lblSubjectLV' | translate}}</label>
                <input class="form-control" [(ngModel)]="model.SubjectLV" name="subjectLV" [required]="isFullContentRequired" />
                <ng-container [ngTemplateOutlet]="validation"
                              [ngTemplateOutletContext]="{ validation: validations.subjectLV }">
                </ng-container>
            </div>

            <div class="form-field" [class.required]="isFullContentRequired">
                <label class="form-label">{{'notification_lblSubjectEN' | translate}}</label>
                <input class="form-control" [(ngModel)]="model.SubjectEN" name="subjectEN" [required]="isFullContentRequired" />
                <ng-container [ngTemplateOutlet]="validation"
                              [ngTemplateOutletContext]="{ validation: validations.subjectEN }">
                </ng-container>
            </div>

            <div class="form-field" [class.required]="isFullContentRequired">
                <label class="form-label">{{'notification_lblMessageLV' | translate}}</label>
                <editor [(ngModel)]="model.MessageLV" name="messageLV" [init]="textEditorConfig"></editor>
                <ng-container [ngTemplateOutlet]="validation"
                              [ngTemplateOutletContext]="{ validation: validations.messageLV }">
                </ng-container>
            </div>

            <div class="form-field" [class.required]="isFullContentRequired">
                <label class="form-label">{{'notification_lblMessageEN' | translate}}</label>
                <editor [(ngModel)]="model.MessageEN" name="messageEN" [init]="textEditorConfig"></editor>
                <ng-container [ngTemplateOutlet]="validation"
                              [ngTemplateOutletContext]="{ validation: validations.messageEN }">
                </ng-container>
            </div>

            <div class="form-field" [class.required]="isShortContentRequired">
                <label class="form-label">{{'notification_lblShortMessageLV' | translate}}</label>
                <textarea class="form-control" [(ngModel)]="model.ShortMessageLV" name="shortMessageLV" rows="3" [required]="isShortContentRequired"></textarea>
                <ng-container [ngTemplateOutlet]="validation"
                              [ngTemplateOutletContext]="{ validation: validations.shortMessageLV }">
                </ng-container>
            </div>

            <div class="form-field" [class.required]="isShortContentRequired">
                <label class="form-label">{{'notification_lblShortMessageEN' | translate}}</label>
                <textarea class="form-control" [(ngModel)]="model.ShortMessageEN" name="shortMessageEN" rows="3" [required]="isShortContentRequired"></textarea>
                <ng-container [ngTemplateOutlet]="validation"
                              [ngTemplateOutletContext]="{ validation: validations.shortMessageEN }">
                </ng-container>
            </div>

            <section>
                <h5>{{'notification_recipients' | translate}}</h5>

                <div class="row">
                    <div class="col">
                        <div class="form-field">
                            <label class="form-label">{{'notification_lblRecipient' | translate}}</label>
                            <input class="form-control"
                                   name="recipientFilterName"
                                   [(ngModel)]="recipientFilterValues.search"
                                   (input)="searchRecipients($event)"
                                   maxlength="50">
                        </div>
                    </div>

                    <div class="col" *ngFor="let n of allChannels">
                        <div class="form-field">
                            <label class="form-label">{{'notification_channel' + n | translate}}</label>
                            <app-select name="recipientFilterChannel_{{n}}"
                                        [(ngModel)]="recipientFilterValues.channels[n]"
                                        [options]="options.requestStatus"
                                        [displayProperty]="'text'"
                                        [valueProperty]="'value'"
                                        [disabled]="!isChannelAvailable(n)"
                                        (selectionChange)="filterRecipients()"></app-select>
                        </div>
                    </div>
                </div>

                <app-table [rows]="recipientRows" [columns]="recipientColumns">
                    <ng-template #rowTemplate let-row>
                        <tr>
                            <td>
                                <div>
                                    {{row.recipient.Name}} {{row.recipient.Surname}}
                                </div>
                                <div class="text-sub">{{row.recipient.Upn}}</div>
                            </td>
                            <td>{{'notification_language' + row.recipient.Language | translate}}</td>
                            <td>
                                <i class="fi fi-rs-check" *ngIf="isRecipientChannelActive(row.recipient, 'MyRsu')"></i>
                            </td>
                            <td>
                                <i class="fi fi-rs-check" *ngIf="isRecipientChannelActive(row.recipient, 'RsuEmail')"></i>
                            </td>
                            <td>
                                <i class="fi fi-rs-check" *ngIf="isRecipientChannelActive(row.recipient, 'Sms')"></i>
                            </td>
                        </tr>
                    </ng-template>
                </app-table>
            </section>

            <section>
                <h5>{{'notification_stats' | translate}}</h5>
                <div class="block-em mt-0">
                    <div class="row">
                        <div class="col-sm data-value" *ngFor="let n of stats">
                            <label>{{'notification_channel' + n.channel | translate}}</label>
                            <div>
                                <div>{{'notification_requestApproved' | translate}}: <span class="text-success">{{n.approved}}</span></div>
                                <div>{{'notification_requestRejected' | translate}}: <span class="text-light">{{n.rejected}}</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div class="form-actions">
                <button class="btn btn-outline" type="button" [routerLink]="['/notifications'] | localize">
                    {{'close' | translate}}
                </button>

                <button class="btn btn-primary" type="button" (click)="send()">
                    <i class="fi fi-rs-paper-plane"></i>
                    {{'notification_btnSend' | translate}}
                </button>
            </div>
        </form>
    </ng-container>
</div>

<ng-template #validation let-validation="validation">
    <ng-container *ngIf="isFormSubmitted">
        <div class="invalid-feedback" *ngFor="let e of getErrors(validation)">
            {{e}}
        </div>
    </ng-container>
</ng-template>
